import './index_mWeb.css';
import { Image, View, Text } from '../../../component';
import I18t from '../../../utilities/locale';
import useTheme from '../../../utilities/hooks/theme';
import React from 'react';

interface Props {
  contestCategory?: any;
  contestCount?: number;
  onPressViewAll?: any;
}

const ContestListHeaderMWeb = ({
  contestCategory = {},
  contestCount = 0,
  onPressViewAll
}: Props) => {
  const { FantasyTheme: theme } = useTheme();
  const { description = '', title = '', imageUrl = '', id = '' } = contestCategory;
  const mainLabel = {
    color: theme.contestListItemHeaderTitle
  };

  const subLabel = {
    color: theme.contestListItemHeaderSubTitle
  };

  return (
    <View className="contest-list-header-container_mWeb" key={id}>
      <View
        style={{
          width: '40px',
          height: '40px'
        }}>
        <Image
          source={imageUrl}
          placeHolderType={'ContestCategory'}
          style={{
            width: '100%',
            height: '100%'
          }}
        />
      </View>
      <View className="contest-list-header-label-content_mWeb">
        <Text className="contest-list-header-main-label_mWeb" style={mainLabel}>
          {title}
        </Text>
        <Text className="contest-list-header-desc-label_mWeb" style={subLabel}>
          {description}
        </Text>
      </View>
      <View
        style={{
          borderBottomColor: theme.contestListItemHeaderSubTitle,
          borderBottomWidth: '1px'
        }}
        className="contest-list-header-view-all-btn_mWeb"
        onPress={() => onPressViewAll(id, title)}>
        <Text className="contest-list-header-view-all-label_mWeb" style={subLabel}>{`${I18t.t(
          'viewMore'
        )} ${contestCount}`}</Text>
      </View>
    </View>
  );
};
export default React.memo(ContestListHeaderMWeb);
